import React, { Component } from 'react'
import { Button } from 'antd'
import PurchaseOrderSection from './PurchaseOrderSection'

class PurchaseOrderEditor extends Component {
  render() {
    const { purchaseOrderSections } = this.props

    const sectionList = purchaseOrderSections
      ? this.props.purchaseOrderSections.map((section, index) => {
          if (!section.markedForDeletion) {
            return (
              <div key={index}>
                <PurchaseOrderSection
                  sectionId={section.id ? section.id : 0}
                  index={index}
                  section={section.name}
                  {...this.props}
                />
              </div>
            )
          } else {
            return ''
          }
        })
      : []

    return (
      <div>
        <div className="row padding0">
          <div className="col-md-12 flexSpaceBetween">
            <h5>Purchase Order Items</h5>
            <Button icon="plus-circle" onClick={() => this.props.addSection()}>
              Add New Section
            </Button>
          </div>
        </div>
        {sectionList}
      </div>
    )
  }
}

export default PurchaseOrderEditor



// WEBPACK FOOTER //
// ./src/components/PurchaseOrderEditor.js